import { useTranslation } from 'react-i18next';
import ReactHtmlParser from 'react-html-parser';

const TextoLegal = ({ lang, legal }) => {

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    return (
        <>
            <section className="u-clearfix u-image u-valign-middle-lg u-valign-middle-sm u-section-1" id="sec-5458" data-image-width="1920" data-image-height="1439" style={{ backgroundImage: "url(/images/web/onboard2/Boreas079.jpg)" }}>
                <h1 className="u-align-center u-custom-font u-font-oswald u-text u-text-default u-text-white u-title u-text-1">{t("Aviso Legal").toLocaleUpperCase()}</h1>
            </section>
            <section className="u-clearfix u-section-2" id="block-10">
                <div className="u-clearfix u-sheet u-valign-middle-lg u-valign-middle-sm u-valign-middle-xl u-sheet-1">
                    {ReactHtmlParser(legal.ladesc)}
                </div>
            </section>
        </>
    );

};
export default TextoLegal;
